<div class="modal modal-full fade" id="Observation-comment" [collapse]="isCollapsed" tabindex="-1">
  <div class="modal-dialog" role="document">
    <div class="modal-content" *ngIf="isEdit">
      <div class="modal-header border-0 mb-4">
        <h5 class="row modal-title w-100 mt-3 sticky">{{ 'SOP_MANAGEMENT.COMMENTS' | translate }}</h5>
        <button type="button" class="close" (click)="closeComments()"></button>
      </div>
      <div class="comment-body modal-body ui-dialog-fixed">
        <div class="col-12">
          <div class="comment-text-container" *ngFor="let comment of comments;let i = index">
            <div class="col-11 comment-card-protocol">
              <p class="comment-time m-0">{{comment.commentDateTime | date:'H:mm'}}</p>
              <p class="comment-step m-0">{{(comment.stepNumber) ? ('SOP_MANAGEMENT.STEP' | translate ) + ' ' +
                comment.stepNumber + ' - ' + (comment.stepName | translate) : ('SOP_OBSERVATION.NO_STEP' | translate)}}
              </p>
            </div>
            <div class="d-flex predefined-section pb-4">
              <div class="quick-cmt mr-2" *ngFor="let predefinedComment of predefinedComments">
                <li [ngClass]="isCommentSelected(predefinedComment, comment) ? 'active' : ''"
                  (click)="selectComment(predefinedComment, comment)">{{ predefinedComment.commentName }}</li>
              </div>
            </div>
            <div class="pr-0 comment-div">
              <textarea inputSanitizer class="text-comt" type="text" required [(ngModel)]="comment.freeTextComment"
                #userCommentFrom="ngModel" placeholder="{{'EVALUATION.COMMENTS' | translate}}"
                maxlength="{{sopObserveCommentsMaxLength}}" [ngModelOptions]="{standalone: true}" rows="3"></textarea>
              <span class="character-count-text">{{ comment.freeTextComment ? comment.freeTextComment.length : 0 }}
                /
                {{sopObserveCommentsMaxLength}} </span>
            </div>
          </div>
          <div *ngIf="comments.length > 0" class="comment-line"></div>
        </div>
      </div>
      <div class="d-flex justify-content-end p-2">
        <button class="btn-cancel-bordered-bd separate-buttons" (click)="cancelEditingComments()">{{
          translationKeys.Authorization.Cancel | translate }}</button>
        <button class="btn btn-continue-bordered-bd" (click)="saveEditingComments()">{{
          translationKeys.Authorization.Save | translate }}</button>
      </div>
    </div>

    <div class="modal-content" *ngIf="!isEdit">
      <div class="modal-header border-0 mb-4">
        <h5 class="row modal-title w-100 mt-3 sticky">{{ 'SOP_MANAGEMENT.COMMENTS' | translate }}</h5>
        <button type="button" class="close" (click)="closeComments()"></button>
      </div>
      <div class="comment-body modal-body ui-dialog-fixed">

        <div class="row justify-content-end mr-3" *ngIf="!isOverviewIndividual && !isEdit && comments && comments.length > 0">
          <a class="btn-edit-icon" (click)="startEditingComments()">
            <img src="assets/ph-bhp-layout/svg/icon-edit.svg">
          </a>
        </div>

        <div class="col-12">
          <div *ngFor="let comment of comments;let i = index">
            <div class="comment-card-protocol">
              <p class="comment-time m-0">{{comment.commentDateTime | date:'H:mm'}}</p>
              <p class="comment-step m-0">{{(comment.stepNumber) ? ('SOP_MANAGEMENT.STEP' | translate ) + ' ' +
                comment.stepNumber + ' - ' + (comment.stepName | translate) : ('SOP_OBSERVATION.NO_STEP' | translate)}}
              </p>
              <p class="comment-text m-0">{{getTextComment(comment) | translate}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>